import React, { useState, useEffect } from 'react';
import { Step, StepLabel, Stepper } from '@mui/material';
import '../../../../App.css';
import "../../../../assets/css/bookingtruckschedule.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faPlus, faChevronLeft, faChevronRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Header from "../../../../Components/Header/Header";
// import Stepper from '../../../../Components/Stepper/Stepper';
import { Dropdown, Row, Col, Form, Modal, Button, Badge } from 'react-bootstrap';
import TopMenu from "../../../../Components/TopMenu/TopMenu";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
// import TruckActive from '../TruckGrid/TruckActive.js';
// import TruckTrash from '../TruckGrid/TruckTrash.js';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Arcv from "../../../../assets/images/archive.svg";
import Trash from "../../../../assets/images/delete.svg";
import Export from "../../../../assets/images/export.svg";
import Exportw from "../../../../assets/images/exportw.png";
import firstImage from '../../../../assets/images/warehouse.png';
import secondImage from '../../../../assets/images/information.png';
import thirdImage from '../../../../assets/images/package.png';
import fourthImage from '../../../../assets/images/report.png';
import { TruckOrderOne, TruckOrderTwo, TruckOrderThree, TruckOrderFour } from "./TruckOrderForms";
import Completed from '../../../../assets/images/Completed.svg';

import TruckGrid from './TruckGrid'

import { withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERLIST, TRUCKORDERSAVE, ADDTRUCKSCHEDULE } from '../../../../Utils/conts';
import { forEach } from 'lodash';

const initialSuggestion = JSON.parse(localStorage.getItem('gridData')) || [];
const initialSuggestions = initialSuggestion.Active || [];

const CustomStepIcon = ({ icon }) => <span className='iconcer'>{icon}</span>;
const steps = [
    { label: (<>Step 1 <br />Type of Truck</>), icon: <img src={firstImage} /> },
    { label: (<>Step 2 <br />Truck Information</>), icon: <img src={secondImage} /> },
    { label: (<>Step 3 <br />Truck Booking</>), icon: <img src={thirdImage} /> },
    { label: (<>Step 4 <br />Adding Documents</>), icon: <img src={fourthImage} /> },
]; // Define your steps

const TruckOrder = () => {

    const [exportGrid, setExportGrid] = useState();

    // Date Function Start
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        // setShow(true);
        const checkOT = localStorage.getItem('OT');
        if (checkOT) {
            localStorage.removeItem('OT');
        }
        window.location.href = '/OrderTruck';
    }
    const handleShow1 = () => {
        setShow(true);
        // window.location.href = '/OrderTruck';
    }

    // Grid Tab Function End
    // Stepper Function Start
    const [activeStep, setActiveStep] = useState(0);
    const dateToday = dateYMD(new Date());
    const [formData, setFormData] = useState({
        truck_type: {
            truck_type: 'B', bookingTruck_type: 'E', existing_date: dateToday, bookingtruck_id: '', bookingtruck_date_id: '',
            hoc_movement_type: '', hoc_board_point: '', hoc_board_address: '', hoc_off_point: '', hoc_off_address: '',
            hoc_date: '', hoc_time: '', new_movement_type: '', new_board_point: '', new_board_address: '', new_off_point: '',
            new_off_address: '', new_date: '', new_time: '', new_board_point_name: '', new_board_address_name: '',
            new_off_point_name: '', new_off_address_name: '', hoc_board_point_name: '', hoc_board_address_name: '',
            hoc_off_point_name: '', hoc_off_address_name: '', selected_days: '', hoc_bookingtruck_no: '',
            hoc_trip_type: 'O', trip_type: 'O', hoc_departure_date: '', hoc_travel_time: '', hoc_start_date: '', hoc_end_date: '',
            hoc_departure_time: '', hoc_selected_days: '',
        },
        truck_information: {
            truck_no: '', truck_load: '', temperature: 'Y', drivers: '', adr: '', remarks: '', drivers_number: '', truck_inf_date: '',
            truck_inf_time: ''
        },
        truck_booking: {
            rateType: 'FR',
            rateId: '',
            boardpoint: '',
            truck_load: '',
            temperature: '',
            drivers: '',
            price: '',
        },
        truck_documents: {},
    });
    const localData = localStorage.getItem('formData');
    // if(localData){
    //     setFormData(JSON.parse(localStorage.formData));
    // }else{
    //     setFormData({
    //     truck_type: {
    //         truck_type: 'B', bookingTruck_type: 'E', existing_date: dateToday, bookingtruck_id: '', bookingtruck_date_id: '',
    //         hoc_movement_type: '', hoc_board_point: '', hoc_board_address: '', hoc_off_point: '', hoc_off_address: '', 
    //         hoc_date: '', hoc_time: '', new_movement_type: '', new_board_point: '', new_board_address: '', new_off_point: '', 
    //         new_off_address: '', new_date: '', new_time: '', new_board_point_name: '', new_board_address_name: '', 
    //         new_off_point_name: '', new_off_address_name: '', hoc_board_point_name: '', hoc_board_address_name: '', 
    //         hoc_off_point_name: '', hoc_off_address_name: '',selected_days:''
    //     },
    //     truck_information: {
    //         truck_no: '', truck_load: '', temperature: 'Y', drivers: '', adr: '', remarks: '', drivers_number: '', truck_inf_date: '',
    //         truck_inf_time: ''
    //     },
    //     truck_booking: {
    //         rateType: 'FR',
    //         rateId: '',
    //         boardpoint: '',
    //         truck_load: '',
    //         temperature: '',
    //         drivers: '',
    //         price: '',
    //     },
    //     truck_documents: { files: [] },
    // });
    // }
    const [completedData, setCompletedData] = useState([]);
    const [statusCount, setStatusCount] = useState([]);
    const [finishStep, setFinishStep] = useState(false);
    function dateYMD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }
    useEffect(() => {
        localStorage.setItem('formData', JSON.stringify(formData));
    }, [formData]);


    // api call for all data submit-------------
    const handleStepClick = (stepIndex) => {
        if (completedData[stepIndex]) {
            setActiveStep(stepIndex);
        }
    };

    const validateFormData = () => {
        let isValid = true;
        if (activeStep === 0) {
            if (!formData.handler_information.handler_address) {
                isValid = false;
            }
            if (!formData.handler_information.handler_werehouse) {
                isValid = false;
            }
        }
        if (activeStep === 1) {
            if (!formData.trip_information.airline_conserned[0]) {
                isValid = false;
            }
            if (!formData.trip_information.movement_type) {
                isValid = false;
            }
            if (!formData.trip_information.type_of_vehicle) {
                isValid = false;
            }
            if (!formData.trip_information.type_of_loading) {
                isValid = false;
            }
        }
        return isValid;
    };


    const stepNext = () => {
        // if (validateFormData()) {
        setCompletedData((prevCompletedData) => ({
            ...prevCompletedData,
            [activeStep]: formData,
        }));

        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        //   }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setFormData(completedData[activeStep - 1] || {});
    };


    const handleFinish = async () => {
        // console.log(formData);

        // if(formData.truck_type.bookingTruck_type=="N"){
        //     const alldata={
        //         booking_type: formData.truck_type.booking_type,
        //         bookingtruck_no: formData.truck_type.bookingtruck_no,
        //         boardpoint: formData.truck_type.boardpoint,
        //         boardpoint_address: formData.truck_type.boardpoint_address,
        //         offpoint: formData.truck_type.offpoint,
        //         offpoint_address: formData.truck_type.offpoint_address,
        //         trip_type: formData.truck_type.trip_type,
        //         departure_date: formData.truck_type.departure_date,
        //         departure_time: formData.truck_type.departure_time,
        //         travel_time: formData.truck_type.travel_time,
        //         selected_days: formData.truck_type.selected_days,
        //         freq_date: formData.truck_type.start_date,
        //         start_date: formData.truck_type.start_date,
        //         end_date: formData.truck_type.end_date
        //     }
        //     try {
        //         const res = await withRFSToken.post(ADDTRUCKSCHEDULE, alldata);
        //         if (res.data.response_code == 200) {

        //         } else {
        //             //toast.error(res.data.response_msg);
        //         }
        //         // });

        //     } catch (error) {
        //         console.error('Error sending request:', error);
        //     }
        // }else{

        // }

        //New
        var allfiles = [];
        if (formData.truck_documents.length > 0) {
            formData.truck_documents.forEach(element => {
                allfiles.push(element.base64)
            });
        }
        const bookingtruckNo = formData.truck_type.bookingtruck_no || formData.truck_type.hoc_bookingtruck_no;
        const boardingPoint = formData.truck_type.boardpoint || formData.truck_type.hoc_boardpoint;
        const boardingPointAdd = formData.truck_type.boardpoint_address || formData.truck_type.hoc_boardpoint_address;
        const offpoint = formData.truck_type.offpoint || formData.truck_type.hoc_offpoint;
        const offpointAdd = formData.truck_type.offpoint_address || formData.truck_type.hoc_offpoint_address;

        const tripType = formData.truck_type.trip_type || formData.truck_type.hoc_trip_type;
        const departureDate = formData.truck_type.departure_date || formData.truck_type.hoc_departure_date;
        const departureTime = formData.truck_type.departure_time || formData.truck_type.hoc_departure_time;
        const travelTime = formData.truck_type.travel_time || formData.truck_type.hoc_travel_time;
        const selectedDays = formData.truck_type.selected_days || formData.truck_type.hoc_selected_days;
        const startDate = formData.truck_type.start_date || formData.truck_type.hoc_start_date;
        const endDate = formData.truck_type.end_date || formData.truck_type.hoc_end_date;
        const bookingType = formData.truck_type.booking_type || formData.truck_type.hoc_movement_type;


        const gdate = formData.truck_type.date || formData.truck_type.hoc_date;
        const gtime = formData.truck_type.new_time || formData.truck_type.hoc_time;
        let updatedFormData = {
            "type_of_truck": formData.truck_type.truck_type,
            "bookingTruck_type": "N",
            "truck_no": formData.truck_information.truck_no,
            "booking_date": formData.truck_information.truck_inf_date,
            // "bookingtruck_id": formData.truck_type.bookingtruck_id,
            // "bookingtruck_date_id": formData.truck_type.bookingtruck_date_id,
            "booking_time": formData.truck_information.truck_inf_time,
            "truck_load": formData.truck_information.truck_load,
            "temperature": formData.truck_information.temperature,
            "driver_number": formData.truck_information.drivers_number,
            "adr": formData.truck_information.adr,
            "remarks": formData.truck_information.remarks,
            "file_paths": allfiles,
            "rate_type": formData.truck_booking.rateType,
            "carriers": formData.truck_booking.rateId,
            "new_schedule_data": {
                booking_type: formData.truck_type.booking_type,
                bookingtruck_no: bookingtruckNo,
                boardpoint: boardingPoint,
                boardpoint_address: boardingPointAdd,
                offpoint: offpoint,
                offpoint_address: offpointAdd,
                trip_type: tripType,
                departure_date: departureDate,
                departure_time: departureTime,
                travel_time: travelTime,
                selected_days: selectedDays,
                freq_date: startDate,
                start_date: startDate,
                end_date: endDate,
                booking_type: bookingType
            },
        }
        if (formData.truck_type.bookingtruck_id) {
            updatedFormData.bookingtruck_id = formData.truck_type.bookingtruck_id;
            updatedFormData.bookingTruck_type = "E";
        }
        if (formData.truck_type.bookingtruck_date_id) {
            updatedFormData.bookingtruck_date_id = formData.truck_type.bookingtruck_date_id;
            updatedFormData.bookingTruck_type = "E";
        }
        try {
            const res = await withRFSToken.post(TRUCKORDERSAVE, updatedFormData)
                .then(function (res) {
                    setCompletedData((prevCompletedData) => ({
                        ...prevCompletedData,
                        [activeStep]: formData,
                    }));
                    setFinishStep(true);
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    // Stepper Function End
    const handleFormDataChange = (formName, data) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [formName]: data,
        }));
        const truck_inf_date = data.existing_date || data.start_date || data.hoc_date;
        const truck_inf_time = data.departure_time || data.departure_time || data.hoc_departure_time;
        if (formName == "truck_type" && truck_inf_date != "" && truck_inf_time != "") {
            setFormData(prevFormData => ({
                ...prevFormData,
                truck_information: {
                    ...prevFormData.truck_information,
                    truck_inf_date: truck_inf_date,
                    truck_inf_time: truck_inf_time,
                }
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [formName]: data,
            }));
        }
    }

    // Search Start
    const [searchData, setSearchData] = useState({ search_area: '', o_id: '' });
    const [searchItems, setSearchItems] = useState({});

    const clearSearch = () => {
        setSearchData({ search_area: '', o_id: '' })
    }
    const handleSearchChange = (event) => {
        const { name, value } = event.target;
        setSearchData(prevData => ({
            ...prevData,
            [name]: value,
            ...(name === 'search_area' && { o_id: '', tr_date: '' }), // Reset `o_id` if `search_area` changes
        }));
        if (name === 'tr_date' && value) {
            fetchSearchList(value)
        } if (name === 'search_area' && value === 'awb_manager') {
            fetchSearchList('', 'awb_manager');
        }
    }
    const fetchSearchList = async (dta, tn) => {
        const payload = { tab_name: tn ?? searchData.search_area, date: dta }
        try {
            const res = await withRFSToken.post('rfs-filter', payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (tn) {
                        setSearchItems({ ...searchItems, awbList: innerData ?? [] });
                    } else {
                        setSearchItems({ ...searchItems, truckList: innerData ?? [] });
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleSearch = async () => {
        if (searchData.search_area === 'booking_truck') {
            localStorage.removeItem('BTDetails');
            const dataToSend = { bookingtruck_date_id: searchData?.o_id, date: searchData?.tr_date, bookingtruck_id: searchData.bookingtruck_id }
            localStorage.setItem('BTDetails', JSON.stringify(dataToSend));
            window.location.href = '/BookingtruckDetails'
        } else if (searchData.search_area === 'truck_order') {
            localStorage.removeItem('TODetails');
            const storageData = { truck_orders_id: searchData.o_id, tab: 'shipment' };
            localStorage.setItem('TODetails', JSON.stringify(storageData));
            window.location.href = '/TruckOrderDetails'
        } else {
            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD: { awb_no: searchData.o_label.trim(' '), awb_id: searchData.o_id },
                Left: {},
                sec: 'D',
                Back: {url: '/TruckOrder', tab: ''}
            };
            localStorage.setItem('OVDetails', JSON.stringify(storageData));
            // localStorage.setItem('tab', 'assets');
            // window.location.href = '/TruckMonitor/OrdersViewDetails'
            window.location.href = '/TruckMonitor/Details'
        }
    }
    // Search End

    return (
        <>
            <div className="">
                <Header logo_url='/TruckOrder' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab position-relative">
                            <TopMenu module='RFS' />
                            <div className='view_filter' style={{ position: 'absolute', top: '12px', right: '0' }}>
                                <Dropdown onToggle={(isOpen) => { if (!isOpen) { clearSearch(); } }}>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faMagnifyingGlass} /> Search
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='filter_menu charter_from'>
                                        <div className='d-flex justify-content-between filter_text'><h3>Search </h3>  <Link to='#' onClick={clearSearch}>Clear</Link></div>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-1">
                                                    <Form.Label>Search Area</Form.Label>
                                                    <Form.Select aria-label="Default select example" value={searchData.search_area} name='search_area' onChange={handleSearchChange}>
                                                        <option value=''>Select</option>
                                                        <option value="awb_manager">AWB No.</option>
                                                        <option value="booking_truck">Scheduled Truck</option>
                                                        {/* <option value="truck_order">Operational Truck</option> */}
                                                    </Form.Select>

                                                </Form.Group>
                                            </Col>
                                            <Col>

                                            </Col>
                                        </Row>
                                        {searchData.search_area &&
                                            <Row>
                                                {searchData.search_area == 'awb_manager' ?
                                                    <Col>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label>Select AWB Number</Form.Label>
                                                            {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                            <Select
                                                                options={searchItems.awbList || []}
                                                                placeholder="Select number"
                                                                className='down_selct'
                                                                onChange={(selected) => {
                                                                    setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label });
                                                                }}
                                                                // isMulti
                                                                // name="status"
                                                                value={searchItems.awbList?.find(value => value.label === searchData.o_label) || ''}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    :
                                                    <>
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>Truck Date</Form.Label>
                                                                <Form.Control type="date" name='tr_date' onChange={handleSearchChange} value={searchData.tr_date} />
                                                            </Form.Group>
                                                        </Col>
                                                        {searchData.tr_date &&
                                                            <Col sm={6}>
                                                                <Form.Group className="mb-1">
                                                                    <Form.Label>{searchData.search_area == 'booking_truck' ? 'Scheduled' : 'Operational'} Truck No.</Form.Label>
                                                                    {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                                    <Select
                                                                        options={searchItems.truckList || []}
                                                                        placeholder="Select number"
                                                                        className='down_selct'
                                                                        onChange={(selected) => {
                                                                            if (searchData.search_area == 'booking_truck') {
                                                                                setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, bookingtruck_id: selected.bookingtruck_id });
                                                                            } else {
                                                                                setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, });
                                                                            }
                                                                        }}
                                                                        // isMulti
                                                                        // name="status"
                                                                        value={searchItems.truckList?.find(value => value.label === searchData.o_label) || ''}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        }

                                                    </>
                                                }
                                            </Row>
                                        }
                                        <div className="mt-3 text-end"><Button variant="primary" className='adduld m-0' onClick={handleSearch}>Search</Button></div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="">
                                <div className="allcontent-fl">
                                    {/* <div className='d-flex justify-content-end mb-3 order_search'>
                                        <div className='search'>
                                            <div className="form-group has-search">
                                                <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                                <input type="text" className="form-control" placeholder="Searcgggggggggh" />
                                            </div>

                                        </div>
                                    </div> */}
                                    <div className="lcontent">
                                        <div className="mb-3 nestedtabs rounded">

                                            <div className='d-flex justify-content-between'>
                                                <div className='d-flex'>
                                                    <button className="addtruck" variant="primary" onClick={handleShow}>
                                                        <span> Order Truck</span>
                                                    </button>
                                                    {/* <button className="addtruck" variant="primary" onClick={handleShow1}>
                                                        <span> Order Truck</span>
                                                    </button> */}
                                                    {console.log('st', statusCount)}
                                                    <div className='doc_sts'>
                                                        <span className="selected doc_open">
                                                            Requested <Badge>{statusCount?.find(dt => dt.planning_status === 'Requested')?.count}</Badge>
                                                        </span>
                                                        <span className="selected doc_proses">
                                                            Offer Received <Badge>{statusCount?.find(dt => dt.planning_status === 'Offer Received')?.count}</Badge>
                                                        </span>
                                                        <span className="selected doc_complt">
                                                            Booked <Badge>{statusCount?.find(dt => dt.planning_status === 'Booked')?.count}</Badge>
                                                        </span>
                                                        <span className="selected doc_rejected">
                                                            Rejected <Badge>{statusCount?.find(dt => dt.planning_status === 'Rejected')?.count}</Badge>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <TruckGrid updateGridData={exportGrid} forwardData={(data) => setStatusCount(data)} />
                                        {/* <Tabs defaultActiveKey="active" id="nested" className="booking_tab" onSelect={handleTabSelect}>
                                            <Tab eventKey="active" title={<span>Active</span>}>
                                                <TruckActive updateGridData={exportGrid} />
                                            </Tab>
                                            <Tab eventKey="trash" title={<span>Trash</span>}>
                                                <TruckTrash updateGridData={exportGrid} />
                                            </Tab>
                                        </Tabs> */}

                                        <Modal size="xl" show={show} onHide={handleClose} centered className='addfrom truck_order'>
                                            <Modal.Header closeButton>
                                            </Modal.Header>
                                            <Modal.Body>

                                                <div className='st-f'>
                                                    <Stepper activeStep={activeStep} alternativeLabel className='rasteper'>
                                                        {steps.map(({ label, icon }, index) => (
                                                            <Step key={index} className={(completedData[index]) ? 'raroot done' : 'raroot'}>
                                                                <StepLabel StepIconComponent={() => <CustomStepIcon icon={icon} className="rastplabel" />} onClick={() => handleStepClick(index)}>{label}</StepLabel>
                                                            </Step>
                                                        ))}
                                                    </Stepper>
                                                    <div className="stepper-right">
                                                        {/* {activeStep === steps.length  */}
                                                        {finishStep ? (
                                                            <div className='w-100 d-flex justify-content-center align-items-center'>
                                                                <div className='complt'>
                                                                    <img src={Completed} alt='' />
                                                                    <h3>Thank you!</h3>
                                                                    <p>Submit was successful</p>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <div className="stepper-frms">
                                                                    {/* <Typography>Step {activeStep + 1}</Typography> */}
                                                                    {/* Render different form components based on the active step */}
                                                                    {/* Example: */}
                                                                    {/* {activeStep === 0 && <TruckOrderOne formData ={formData.handler_information} onFormDataChange={(data) => handleFormDataChange('handler_information', data)} />}
                                    {activeStep === 1 && <TruckOrderTwo formData ={formData.trip_information} onFormDataChange2={(data) => handleFormDataChange('trip_information', data)} />}
                                    {activeStep === 2 && <TruckOrderThree formData ={formData.images} onFormDataChange6={(data) => handleFormDataChange('images', data)} />}
                                    {activeStep === 3 && <TruckOrderFour formData ={formData.driver_information} onFormDataChange5={(data) => handleFormDataChange('driver_information', data)} />} */}

                                                                    {activeStep === 0 && <TruckOrderOne formData={formData.truck_type} onFormDataChange={(data) => handleFormDataChange('truck_type', data)} />}
                                                                    {activeStep === 1 && <TruckOrderTwo formData={formData.truck_information} onFormDataChange2={(data) => handleFormDataChange('truck_information', data)} />}
                                                                    {activeStep === 2 && <TruckOrderThree formData={formData.truck_booking} onFormDataChange3={(data) => handleFormDataChange('truck_booking', data)} />}
                                                                    {activeStep === 3 && <TruckOrderFour formData={formData.truck_documents} onFormDataChange4={(data) => handleFormDataChange('truck_documents', data)} />}

                                                                    {/* {activeStep === 6 && <CreateReportFormOne />} */}
                                                                    <div className='nxtbtn'>
                                                                        <Button disabled={activeStep === 0} onClick={stepBack}>
                                                                            Back
                                                                        </Button>
                                                                        <Button className='trnext' variant="contained" onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}>
                                                                            {activeStep === steps.length - 1 ? 'Send Request' : 'Next'}
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                                <div className='stepper-frm-info'>
                                                                    {Object.entries(completedData).map(([step, data], index) => (
                                                                        <div key={step} variant="outlined" className='infoarm'>
                                                                            <div>
                                                                                {step === '0' && (
                                                                                    <div className='infobox'>
                                                                                        <span className='rastp'>Step 1</span>
                                                                                        <h2>Type of Truck</h2>
                                                                                        <ul>
                                                                                            <li>
                                                                                                <span>Truck Type: </span>
                                                                                                <span> {completedData[step].truck_type.truck_type == 'B' ? 'Boocking Truck' : 'Ad Hoc'}</span>
                                                                                            </li>

                                                                                            {completedData[step].truck_type.truck_type == 'B' ? (
                                                                                                <>
                                                                                                    {completedData[step].truck_type.bookingTruck_type == 'E' ? (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span>Bookingtruck No: </span>
                                                                                                                <span> {completedData[step].truck_type.bookingtruck_no}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Date: </span>
                                                                                                                <span> {completedData[step].truck_type.date}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Boardpoint: </span>
                                                                                                                <span> {completedData[step].truck_type.board_point}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Offpoint: </span>
                                                                                                                <span> {completedData[step].truck_type.off_point}</span>
                                                                                                            </li>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <li>
                                                                                                                <span>Truck Type: </span>
                                                                                                                <span> {completedData[step].truck_type.booking_type == 'E' ? 'Export' : 'Import'}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Bookingtruck No: </span>
                                                                                                                <span> {completedData[step].truck_type.bookingtruck_no}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Boardpoint: </span>
                                                                                                                <span> {completedData[step].truck_type.boardpoint_name}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Boardpoint Address: </span>
                                                                                                                <span> {completedData[step].truck_type.boardpoint_address_name}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Offpoint: </span>
                                                                                                                <span> {completedData[step].truck_type.offpoint_name}</span>
                                                                                                            </li>
                                                                                                            <li>
                                                                                                                <span>Offpoint Address: </span>
                                                                                                                <span> {completedData[step].truck_type.offpoint_address_name}</span>
                                                                                                            </li>

                                                                                                            <li>
                                                                                                                <span>Trip Type: </span>
                                                                                                                <span> {completedData[step].truck_type.trip_type == 'O' ? 'One-Off' : 'Frequent'}</span>
                                                                                                            </li>
                                                                                                            {completedData[step].truck_type.trip_type == 'O' ? (
                                                                                                                <>
                                                                                                                    <li>
                                                                                                                        <span>Departure Date: </span>
                                                                                                                        <span> {completedData[step].truck_type.departure_date}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Departure Time: </span>
                                                                                                                        <span> {completedData[step].truck_type.departure_time}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Est. Travel Time: </span>
                                                                                                                        <span> {completedData[step].truck_type.travel_time}</span>
                                                                                                                    </li>

                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <li>
                                                                                                                        <span>Days: </span>
                                                                                                                        <span> {completedData[step].truck_type.selected_days}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Bookingtruck Start Date: </span>
                                                                                                                        <span> {completedData[step].truck_type.start_date}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Bookingtruck End Date: </span>
                                                                                                                        <span> {completedData[step].truck_type.end_date}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Departure Time: </span>
                                                                                                                        <span> {completedData[step].truck_type.departure_time}</span>
                                                                                                                    </li>
                                                                                                                    <li>
                                                                                                                        <span>Est. Travel Time: </span>
                                                                                                                        <span> {completedData[step].truck_type.travel_time}</span>
                                                                                                                    </li>
                                                                                                                </>
                                                                                                            )}



                                                                                                        </>
                                                                                                    )}

                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <li>
                                                                                                        <span>Movement Type: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_movement_type == 'E' ? 'Export' : 'Import'}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Boardpoint: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_boardpoint_name}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Boardpoint Address: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_boardpoint_address_name}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Offpoint: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_offpoint_name}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Offpoint Address: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_offpoint_address_name}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Date: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_date}</span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span>Time: </span>
                                                                                                        <span> {completedData[step].truck_type.hoc_time}</span>
                                                                                                    </li>
                                                                                                </>
                                                                                            )}

                                                                                        </ul>
                                                                                    </div>
                                                                                )}
                                                                                {step === '1' && (

                                                                                    <div className='infobox'>
                                                                                        <span className='rastp'>Step 2</span>
                                                                                        <h2>Truck Informaion</h2>
                                                                                        <ul>
                                                                                            <li>
                                                                                                <span>Operational Truck No: </span>
                                                                                                <span>{completedData[step].truck_information.truck_no}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Date: </span>
                                                                                                <span>{completedData[step].truck_information.truck_inf_date}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Time: </span>
                                                                                                <span>{completedData[step].truck_information.truck_inf_time}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Truck Load: </span>
                                                                                                <span>{completedData[step].truck_information.truck_load == "F" ? 'FLT' : 'LTL'}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Temperature Controled: </span>
                                                                                                <span>{completedData[step].truck_information.temperature == "Y" ? 'YES' : 'NO'}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Number off Drivers: </span>
                                                                                                <span>{completedData[step].truck_information.drivers_number}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>ADR Required: </span>
                                                                                                <span>{completedData[step].truck_information.adr == "Y" ? 'YES' : 'NO'}</span>
                                                                                            </li>
                                                                                            <li>
                                                                                                <span>Remarks: </span>
                                                                                                <span>{completedData[step].truck_information.remarks}</span>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>

                                                                                )}
                                                                                {step === '2' && (
                                                                                    <>
                                                                                        <div className='infobox'>
                                                                                            <span className='rastp'>Step 3</span>
                                                                                            <h2>Truck Booking</h2>
                                                                                            <ul>
                                                                                                <li>
                                                                                                    <span>Rate Type: </span>
                                                                                                    <span> {completedData[step].truck_booking.rateType == 'FR' ? 'Fixed Rate' : 'Free Market'}</span>
                                                                                                </li>
                                                                                                {completedData[step].truck_booking.rateType == 'FR' ? (
                                                                                                    <>
                                                                                                        <li>
                                                                                                            <span>Boardpoint: </span>
                                                                                                            <span>{completedData[step].truck_booking.boardpoint} </span>
                                                                                                        </li>
                                                                                                        <li>
                                                                                                            <span>Truck Load: </span>
                                                                                                            <span>{completedData[step].truck_booking.truck_load} </span>
                                                                                                        </li>
                                                                                                        <li>
                                                                                                            <span>Temperature: </span>
                                                                                                            <span>{completedData[step].truck_booking.temperature} </span>
                                                                                                        </li>
                                                                                                        <li>
                                                                                                            <span>Drivers: </span>
                                                                                                            <span>{completedData[step].truck_booking.drivers} </span>
                                                                                                        </li>
                                                                                                        <li>
                                                                                                            <span>Price: </span>
                                                                                                            <span>{completedData[step].truck_booking.price} </span>
                                                                                                        </li>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>

                                                                                                    </>
                                                                                                )}

                                                                                            </ul>
                                                                                        </div>






                                                                                    </>
                                                                                )}
                                                                                {step === '3' && (

                                                                                    <div className='infobox'>
                                                                                        <span className='rastp'>Step 5</span>
                                                                                        <h2>Documents</h2>

                                                                                    </div>

                                                                                )}


                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TruckOrder;